
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Y5ZE", function(module, exports) {

$parcel$export(module.exports, "default", () => $741e5dc94144fd09$export$2e2bcd8739ae039);

var $7Yi7V = parcelRequire("7Yi7V");
let $741e5dc94144fd09$var$User = {
    list () {
        return fetch(`${(0, $7Yi7V.API_PATH)}/3b5cbc16ec0da4e52934`).then((res)=>res.json());
    },
    info (id) {
        return fetch(`${(0, $7Yi7V.API_PATH)}/${id}`).then((res)=>{
            if (res.ok) return res.json();
            throw new Error("Fetch request failed");
        }).then((data)=>data[0]);
    }
};
var $741e5dc94144fd09$export$2e2bcd8739ae039 = $741e5dc94144fd09$var$User;

});
parcelRegister("7Yi7V", function(module, exports) {

$parcel$export(module.exports, "API_PATH", () => $5cdc329eeebd56d0$export$3dd4dc5621aeefdb);
$parcel$export(module.exports, "TYPE_COLORS", () => $5cdc329eeebd56d0$export$64006c1d938b537);
$parcel$export(module.exports, "TYPE_COLORS_INV", () => $5cdc329eeebd56d0$export$522336a0108d73c8);
const $5cdc329eeebd56d0$export$f5a9c80fee7ea2e0 = 151;
const $5cdc329eeebd56d0$export$3dd4dc5621aeefdb = "https://api.npoint.io";
const $5cdc329eeebd56d0$export$64006c1d938b537 = {
    normal: "#A8A878",
    fire: "#F08030",
    water: "#6890F0",
    electric: "#F8D030",
    grass: "#78C850",
    ice: "#98D8D8",
    fighting: "#C03028",
    poison: "#A040A0",
    ground: "#E0C068",
    flying: "#A890F0",
    psychic: "#F85888",
    bug: "#A8B820",
    rock: "#B8A038",
    ghost: "#705898",
    dragon: "#7038F8",
    dark: "#705848",
    steel: "#B8B8D0",
    fairy: "#EE99AC"
};
const $5cdc329eeebd56d0$export$522336a0108d73c8 = {
    normal: "#212121",
    fire: "#212121",
    water: "#212121",
    electric: "#212121",
    grass: "#212121",
    ice: "#212121",
    fighting: "#FFFFFF",
    poison: "#FFFFFF",
    ground: "#212121",
    flying: "#212121",
    psychic: "#FFFFFF",
    bug: "#212121",
    rock: "#212121",
    ghost: "#FFFFFF",
    dragon: "#FFFFFF",
    dark: "#FFFFFF",
    steel: "#212121",
    fairy: "#212121"
};
const $5cdc329eeebd56d0$export$fdf689e946f60142 = {
    hp: "HP",
    attack: "ATK",
    defense: "DEF",
    "special-attack": "SATK",
    "special-defense": "SDEF",
    speed: "SPD"
};

});



var $9Y5ZE = parcelRequire("9Y5ZE");
const $c31d517097c02e75$var$MAX_POKEMON = 151;
const $c31d517097c02e75$var$listWrapper = document.querySelector(".list-wrapper");
const $c31d517097c02e75$var$searchInput = document.querySelector("#search-input");
const $c31d517097c02e75$var$numberFilter = document.querySelector("#number");
const $c31d517097c02e75$var$nameFilter = document.querySelector("#name");
const $c31d517097c02e75$var$notFoundMessage = document.querySelector("#not-found-message");
let $c31d517097c02e75$var$users = [];
document.body.style.opacity = "1";
document.addEventListener("DOMContentLoaded", ()=>{
    (0, $9Y5ZE.default).list().then((data)=>{
        $c31d517097c02e75$var$users = data;
        $c31d517097c02e75$var$displayUsers(data);
        return data;
    }).then((data)=>{
        $c31d517097c02e75$var$searchInput.addEventListener("keyup", ()=>{
            const searchTerm = $c31d517097c02e75$var$searchInput.value.toLowerCase();
            let filteredUsers = [];
            if ($c31d517097c02e75$var$numberFilter.checked) filteredUsers = $c31d517097c02e75$var$users.filter((user)=>user.number.toString().startsWith(searchTerm));
            else if ($c31d517097c02e75$var$nameFilter.checked) filteredUsers = $c31d517097c02e75$var$users.filter((user)=>user.name.toLowerCase().startsWith(searchTerm));
            else filteredUsers = $c31d517097c02e75$var$users;
            $c31d517097c02e75$var$displayUsers(filteredUsers);
            $c31d517097c02e75$var$notFoundMessage.style.display = filteredUsers.length === 0 ? "block" : "none";
            document.querySelector(".search-close-icon").addEventListener("click", ()=>{
                $c31d517097c02e75$var$searchInput.value = "";
                $c31d517097c02e75$var$displayUsers(data);
                $c31d517097c02e75$var$notFoundMessage.style.display = "none";
            });
        });
    });
});
let $c31d517097c02e75$var$displayUsers = (users)=>{
    $c31d517097c02e75$var$listWrapper.innerHTML = "";
    users.sort((a, b)=>a.number - b.number).forEach((user)=>{
        const listItem = document.createElement("div");
        listItem.className = "list-item";
        listItem.innerHTML = `
        <div class="number-wrap">
            <p class="caption-fonts">#${user.number}</p>
        </div>
        <div class="img-wrap">
            <img src="${user.image}" alt="${user.name}" />
        </div>
        <div class="name-wrap">
            <p class="body3-fonts">${user.name}</p>
        </div>
    `;
        listItem.addEventListener("click", async ()=>{
            window.location.href = `./detail.html?id=${user.id}`;
        });
        $c31d517097c02e75$var$listWrapper.appendChild(listItem);
    });
};


//# sourceMappingURL=index.dbec2626.js.map
